import { useMutation } from '@tanstack/react-query';
import { GenQrBidvVAEntity, BidvVirtualAccountService } from 'services/openapi';

export const useGenQrBidvVAMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      GenQrBidvVAEntity,
      Error,
      { vaPrefix: string; endCode: string }
    >({
      mutationFn: (variables) =>
        BidvVirtualAccountService.bidvVaControllerGenQr(
          variables.vaPrefix,
          variables.endCode,
        ),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
